/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPatientRequestBodyTypename = "PutPatientRequestBody" as const;

/**
 *
 * @export
 * @interface PutPatientRequestBody
 */
export interface PutPatientRequestBody {
  /**
   *
   * @type {number}
   * @memberof PutPatientRequestBody
   */
  familyAccountId?: number;
  /**
   *
   * @type {string}
   * @memberof PutPatientRequestBody
   */
  requestToken: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPatientRequestBody
   */
  readonly __typename?: string;
}

export function PutPatientRequestBodyFromJSON(json: any): PutPatientRequestBody {
  return PutPatientRequestBodyFromJSONTyped(json, false);
}

export function PutPatientRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutPatientRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPatientRequestBodyTypename,

    familyAccountId: !exists(json, "family_account_id") ? undefined : json["family_account_id"],
    requestToken: json["request_token"],
  };
}

export function PutPatientRequestBodyToJSON(object?: PutPatientRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    family_account_id: value.familyAccountId,
    request_token: value.requestToken,
  };
}
